export default defineNuxtRouteMiddleware( async (to, from) => {
    const {groupTypes} = await useGroupTypes();
    const query = useState('catalog-queries')

    if (groupTypes.value.length == 0) {
        abortNavigation()
    }

    if (to.query.products == undefined && to.query.type == undefined) {
        if (query.value) {
            return navigateTo({
                path: to.path,
                query: {...query.value}
            })
        } else {
            return navigateTo({
                path: to.path,
                query: {
                    type: groupTypes.value[0].id
                }
            })
        }
    }

    query.value = to.query
})
